function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var sharedHeaderStyle = {
  width: 'inherit',
  top: 0,
  left: 0,
  position: 'fixed',
  backgroundColor: 'brand.main'
};
export var externalLayoutTheme = {
  baseStyle: _ref => {
    var {
      columns
    } = _ref;
    return {
      container: {
        height: '100%',
        width: '100%',
        position: 'relative',
        backgroundColor: 'neutral.white',
        // Aligns the loader to the center
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      wrapper: {
        display: 'flex',
        flexDirection: 'column',
        height: 'inherit',
        width: 'inherit',
        alignItems: 'center',
        overflowY: 'auto',
        _focusVisible: {
          outlineColor: 'focus.focus',
          outlineWidth: '2px'
        }
      },
      header: _objectSpread(_objectSpread({}, sharedHeaderStyle), {}, {
        height: {
          xs: '56px',
          s: '176px'
        }
      }),
      fixedHeader: _objectSpread(_objectSpread({}, sharedHeaderStyle), {}, {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        alignItems: 'center',
        height: {
          xs: '56px',
          s: '72px'
        },
        paddingX: {
          xs: 's',
          s: 'm',
          xl: 'm'
        },
        zIndex: 1100,
        gap: 'xs'
      }),
      headerContainer: {
        gridRow: '1 / -1',
        justifySelf: 'flex-end'
      },
      logoContainer: {
        gridRow: '-1 / 1',
        justifySelf: 'flex-start'
      },
      grid: {
        maxWidth: '1638px',
        display: 'grid',
        gridTemplateColumns: "repeat(".concat(columns, ", minmax(0, 1fr))"),
        gridTemplateRows: '1fr',
        height: 'inherit',
        width: 'inherit',
        gap: {
          xs: 's',
          s: 'm'
        },
        paddingX: {
          xs: 'none',
          s: 'xxl',
          xl: 'xxl'
        },
        paddingY: {
          xs: 'none',
          s: 'xxxl'
        },
        overflow: 'initial',
        flexGrow: 1,
        zIndex: {
          xs: 0,
          s: 1000
        }
      },
      gridItemContent: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: {
          xs: '56px',
          s: 'none'
        },
        gap: {
          xs: 'm',
          s: 'l',
          xl: 'xl'
        },
        width: '100%',
        gridColumnStart: {
          xs: 1,
          s: 2,
          m: 3,
          xl: 6
        },
        gridColumnEnd: {
          xs: -1,
          s: -2,
          m: -3,
          xl: -6
        }
      }
    };
  }
};
//# sourceMappingURL=ExternalLayout.theme.js.map